import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../../../assets/logo.png';

const routesWithHero = new Set(['/', '/sobre', '/visitas', '/calendario', '/loja', '/aulas', '/contato']);

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Sobre', path: '/sobre' },
  { label: 'Visitas e Experiências', path: '/visitas' },
  { label: 'Aulas Regulares', path: '/aulas' },
  { label: 'Calendário', path: '/calendario' },
  { label: 'Loja', path: '/loja' },
  // { label: 'Podcast', path: '/podcast' },
  { label: 'Contato', path: '/contato' },
];

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const hasHero = routesWithHero.has(location.pathname);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Floating nav overlay */}
      <div className="fixed top-0 left-0 right-0 z-50 pointer-events-none">
        <div className="container flex items-center justify-between py-4">
          <Link to="/" className="pointer-events-auto">
            <img src={logo} alt="Casa do Pandeiro" className="h-20 w-auto drop-shadow-lg ml-4" />
          </Link>

          <button
            className={`pointer-events-auto p-2 rounded-md transition-colors ${hasHero ? 'text-primary-foreground' : 'text-foreground'}`}
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={42} /> : <Menu size={42} />}
          </button>
        </div>
      </div>

      {/* Slide-out nav menu */}
      {open && (
        <div className="fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <nav className="absolute right-0 top-0 h-full w-72 bg-background shadow-xl pt-20 px-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={`block px-4 py-3 rounded-md text-sm font-medium transition-colors hover:bg-secondary ${
                  location.pathname === item.path
                    ? 'text-primary bg-secondary'
                    : 'text-muted-foreground'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}

      <main className="flex-1">{children}</main>

      <footer className="border-t bg-primary text-primary-foreground">
        <div className="container py-6">
          <div className="flex flex-col gap-3">
            <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="text-sm opacity-80 hover:opacity-100 transition-opacity"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            <div className="text-center text-sm text-accent space-y-1">
              <p>Travessa do Ouvidor, 36 — Centro, Rio de Janeiro — RJ</p>
              <p>Segunda a sábado, das 10h às 17h; fechamento pode variar conforme a programação anunciada.</p>
            </div>
            <div className="text-center text-xs opacity-60">
              © {new Date().getFullYear()} Casa do Pandeiro. Todos os direitos reservados.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
